// extracted by mini-css-extract-plugin
export default {"modalOverlay":"errorMod_modalOverlay__rLL1s","modal":"errorMod_modal__YSMY7","textDiv":"errorMod_textDiv__IMdur","divButtons":"errorMod_divButtons__tpEMQ"};